import { Collection, GeneralSettings, StringUtil, UrlUtil } from ".";

export class ServiceAddresses {
    private static _ON_PREM_URL: string;
    private static apiContext: string = "mcleod-api-lme";
    private static localHostServerPort = 8080;
    private static defaultAddresses: Collection<string> = {};

    public static get ON_PREM_URL(): string {
        this._ON_PREM_URL ??= this.buildOnPremUrl();
        return this._ON_PREM_URL;
    }

    private static buildOnPremUrl(): string {
        const baseUrl = this.appConnectionAddress || window.location.origin;

        if (this.isLocalhost(baseUrl)) {
            return this.buildLocalhostUrl(baseUrl);
        }
        if (this.isAndroidEmulator(baseUrl)) {
            return this.buildAndroidEmulatorUrl();
        }
        if (this.isSSOUrl(baseUrl)) {
            return this.buildSSOUrl();
        }
        return this.buildUrlFromOrigin(baseUrl);
    }

    private static isLocalhost(url: string): boolean {
        return url.indexOf("localhost") >= 0;
    }

    /**
     * Android devices: localhost is a reference to the device itself. 10.0.2.2
     * is a loopback interface to reference the localhost in which the emu is running on.
     */
    private static isAndroidEmulator(url: string): boolean {
        return url.toLowerCase().indexOf("http://10.0.2.2:") === 0;
    }

    private static isSSOUrl(url: string): boolean {
        return url.indexOf("onemcleod.com") >= 0 || url.indexOf("mcleodraptor.com") >= 0;
    }

    private static buildLocalhostUrl(url: string): string {
        const localHostPos = url.indexOf("localhost");
        const slashPos = url.lastIndexOf("/", localHostPos);
        const hostname = url.substring(slashPos + 1, localHostPos + 9);
        return `http://${hostname}:${this.localHostServerPort}/`;
    }

    private static buildAndroidEmulatorUrl(): string {
        return `http://10.0.2.2:${this.localHostServerPort}/`;
    }

    private static buildSSOUrl(): string {
        // TODO: "temporary" hard coding
        return "https://api.auth.develop.onemcleod.com/";
    }

    private static buildUrlFromOrigin(url: string): string {
        if (url && url.indexOf(this.apiContext) > -1) {
            return url;
        }
        return UrlUtil.joinUrl(url, this.apiContext);
    }

    public static getEndpointUrl(endpoint: string) {
        if (endpoint.indexOf("://") >= 0)
            return endpoint;
        const serviceName = StringUtil.stringBefore(endpoint, ":", false, null);
        endpoint = StringUtil.stringAfter(endpoint, ":", false, endpoint);
        return UrlUtil.joinUrl(ServiceAddresses.get(serviceName), endpoint);
    }

    public static setLocalHostServerPort(value: number) {
        ServiceAddresses.localHostServerPort = value;
    }

    /**
       * This method sets the first path of the context path of the URL that is used when making api calls.
        * @param value
    */
    public static setContextPath(value: string) {
        this.apiContext = value;
    }

    public static get(serviceName: string) {
        let result = serviceName == null ? null : GeneralSettings.getSingleton().getServiceAddress(serviceName);
        if (result == null) {
            result = this.defaultAddresses[serviceName] || ServiceAddresses.ON_PREM_URL;
        }
        return result;
    }

    public static setDefaultAddress(serviceName: string, address: string) {
        this.defaultAddresses[serviceName] = address;
    }

    private static get appConnectionAddress(): string | null {
        return this.defaultAddresses['mcleod-mobile-origin'];
    }
}
